import { Notify } from 'quasar'

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
function NotifyInit() {
  Notify.setDefaults({
    position: 'top',
  })

  Notify.registerType('error', {
    icon: 'warning',
    progress: true,
    classes: 'notify-error',
    position: 'top-left',
    timeout: 3000,
  })

  Notify.registerType('sucess', {
    icon: 'check_circle',
    progress: true,
    classes: 'notify-sucess',
    position: 'top-left',

    timeout: 3000,
  })

  Notify.registerType('alert', {
    icon: 'warning',
    progress: true,
    classes: 'notify-alert',
    position: 'top-left',

    timeout: 3000,
  })
}

const NotifyError = (text, opts) =>
  Notify.create({ type: 'error', message: text, ...opts })

const NotifySucess = (text, opts) =>
  Notify.create({
    icon: 'check_circle',
    progress: true,
    classes: 'notify-sucess',
    position: 'top-left',
    timeout: 3000,
    message: text,
    ...opts,
  })

const NotifyAlert = (text, opts) =>
  Notify.create({ type: 'alert', message: text, ...opts })

export { NotifyError, NotifySucess, NotifyAlert, NotifyInit }
